import { z } from "zod";
import { FavoriteSchema } from "./Favorite";
import { ProductSchema } from "./Product";

export const FavoritePositionsFieldsSchema = z.object({
  id: z.number(),
  creationDate: z.string(),
  favorite: FavoriteSchema,
  product: z.union([ProductSchema, z.any()]),
});

export const PartialFavoritePositionsFieldsSchema =
  FavoritePositionsFieldsSchema.deepPartial();

export const FavoritePositionsExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
});
export const PartialFavoritePositionExtraFieldsSchema =
  FavoritePositionsExtraFieldsSchema.deepPartial();

export const FavoritePositionSchema = z.intersection(
  FavoritePositionsFieldsSchema,
  FavoritePositionsExtraFieldsSchema
);

export type FavoritePositionFields = z.infer<
  typeof FavoritePositionsFieldsSchema
>;
export type PartialFavoritePositionFields = z.infer<
  typeof PartialFavoritePositionsFieldsSchema
>;
export type FavoritePositionExtraFields = z.infer<
  typeof FavoritePositionsExtraFieldsSchema
>;
export type PartialFavoritePositionExtraFields = z.infer<
  typeof PartialFavoritePositionExtraFieldsSchema
>;
export type FavoritePosition = z.infer<typeof FavoritePositionSchema>;
